/**
 * Single source of truth for "where does an authenticated user of this role
 * belong". Used by the root "/" redirect and ProtectedRoute so a role
 * mismatch (or a bare "/") never dumps a logged-in user on /login.
 */
export const ROLE_HOME = {
  admin: '/admin/home',
  super_admin: '/admin/home',
  talent: '/talent/home',
  client: '/client/home',
  agency: '/agency/dashboard',
  agency_staff: '/agency/crm',
  ai_creator: '/creator/dashboard',
};

export function roleHome(role) {
  return ROLE_HOME[role] || '/login';
}

export default roleHome;
